<script setup lang="ts">
import { computed } from 'vue'
import { Toaster } from '@/components/ui/sonner'
import PageLoader from '@/components/app/PageLoader.vue'
import StepUpDialog from '@/components/app/StepUpDialog.vue'
import { useNavigationLoading } from '@/composables/useNavigationLoading'
import { useTheme } from '@/composables/useTheme'

const { theme } = useTheme()
const { ready, slowNavigation } = useNavigationLoading()
const loading = computed(() => !ready.value || slowNavigation.value)
</script>

<template>
  <router-view />
  <!-- Modale de second facteur, ouverte par le client API sur un refus STEP_UP_REQUIRED. -->
  <StepUpDialog />
  <!-- Retours d'action (SP-27) : succès et erreurs des mutations, voir lib/query.ts. -->
  <Toaster :theme="theme" position="top-right" :offset="24" :duration="4000" close-button />
  <Transition name="fade">
    <PageLoader v-if="loading" />
  </Transition>
</template>
